import { render, staticRenderFns } from "./UserPrefix.vue?vue&type=template&id=2b1c564d&"
import script from "./UserPrefix.vue?vue&type=script&lang=js&"
export * from "./UserPrefix.vue?vue&type=script&lang=js&"
import style0 from "./UserPrefix.vue?vue&type=style&index=0&id=2b1c564d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports